import React, { FC, useContext, useState } from 'react'
import { Trans, t } from '@lingui/macro'
import _ from 'lodash'
import { TimeUnitEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { AnalyticsHighlight } from '../AnalyticsHighlight'
import { AnalyticsHeader } from '../AnalyticsHeader'
import BorderedBox from '../../../components/common/bordered-box/BorderedBox'
import AnalyticsChart from '../components/AnalyticsChart'
import { graphOptions } from '../chartOptions'
import SearchOverviewTable from './SearchOverviewTable'
import Loader from '../../../components/common/loader/Loader'
import { useSearchAnalyticsQuery } from './SearchOverviewTable.codegen'
import { AnalyticsContext } from '../AnalyticsContext'
import { AnalyticsFiltersEnum } from '../constants'

const Search: FC<{}> = () => {
  const { filterAsQueryVariables } = useContext(AnalyticsContext)
  const [chartTimeUnit, setChartTimeUnit] = useState<TimeUnitEnum>(
    TimeUnitEnum.DAY
  )
  const { data, loading } = useSearchAnalyticsQuery({
    fetchPolicy: 'cache-first',
    variables: {
      filter: _.omit(filterAsQueryVariables, 'groupIds'),
      chartTimeUnit
    }
  })

  if (loading) {
    return <Loader />
  }

  const analytics = data?.analytics

  const renderAnalyticsBoxes = () => {
    return (
      <div className="AnalyticsRow">
        <BorderedBox className="AnalyticsRow__box">
          <div className="AnalyticsHighlight__row">
            <AnalyticsHighlight
              value={analytics?.search.searchesCount}
              icon="magnifier"
              description={t`Total searches`}
              iconColor="green"
            />
            <AnalyticsHighlight
              value={analytics?.search.searchesWithNoResultsCount}
              icon="ban"
              description={t`Searches with no result`}
              iconColor="red"
            />
            <AnalyticsHighlight
              value={analytics?.search.uniqueUsersWhoUsedSearchCount}
              icon="people"
              description={t`People searching`}
              iconColor="blue"
            />
          </div>

          <AnalyticsChart
            width={800}
            height={160}
            config={{
              type: 'line',
              options: graphOptions
            }}
            data={[
              { dataset: analytics?.search.searchByTimeUnit },
              {
                dataset: analytics?.search.searchNoResultsByTimeUnit,
                color: '239, 105, 105'
              }
            ]}
            onGranularityChanged={setChartTimeUnit}
            granularity={chartTimeUnit}
          />
        </BorderedBox>
      </div>
    )
  }

  return (
    <>
      <AnalyticsHeader
        showFilterPanel
        activeFilters={[AnalyticsFiltersEnum.DATE_FILTER]}
      >
        <Trans>Searches</Trans>
      </AnalyticsHeader>

      <>
        {renderAnalyticsBoxes()}
        <SearchOverviewTable />
      </>
    </>
  )
}

export default Search
